/* eslint-disable no-useless-constructor */
export class modelDetailsTicketBooking {
    // constructor() { };
    detailsTicketBooking = {
        "maLichChieu": 45841,
        "tenCumRap": "CGV - Aeon Bình Tân",
        "tenRap": "Rạp 4",
        "diaChi": "Tầng 3, TTTM Aeon Mall Bình Tân, Số 1 đường số 17A, khu phố 11, Bình Trị Đông B, Bình Tân",
        "tenPhim": "Bui Nguyen {huong Giao",
        "hinhAnh": "http://movieapi.cyberlearn.vn/hinhanh/bui-nguyen-{huong-giao_gp01.png",
        "ngayChieu": "29/05/2022",
        "gioChieu": "07:05"
    }
    seat = [
        {
            "maGhe": 57481,
            "tenGhe": "01",
            "maRap": 514,
            "loaiGhe": "Thuong",
            "stt": "01",
            "giaVe": 150000,
            "daDat": false,
            "taiKhoanNguoiDat": null
        },
        {
            "maGhe": 57482,
            "tenGhe": "02",
            "maRap": 514,
            "loaiGhe": "Thuong",
            "stt": "02",
            "giaVe": 150000,
            "daDat": false,
            "taiKhoanNguoiDat": null
        },
        {
            "maGhe": 57483,
            "tenGhe": "03",
            "maRap": 514,
            "loaiGhe": "Thuong",
            "stt": "03",
            "giaVe": 150000,
            "daDat": true,
            "taiKhoanNguoiDat": null
        },
    ]
}


